import { Box } from '@chakra-ui/react'

export const OwnersManual = () => (
  <Box>
    <h1>OwnersManual</h1>
  </Box>
)
